import React from 'react';
import ReactDOM from 'react-dom';
import { CustomWindow } from '../legislation.types';
import { snakeToCamel } from '../../../caseUtils';
import { LegislationApp } from './LegislationApp';

declare let window: CustomWindow;

const target = document.querySelector(`[data-react=doctrine-react]`);
if (target) {
  ReactDOM.render(
    <LegislationApp
      legislationInfosAll={snakeToCamel(window.legislation_infos)}
    />,
    target,
  );
} else {
  // eslint-disable-next-line no-console
  console.log(`doctrine-react is not visible in the DOM`);
}
